import LogoMark from './LogoMark';

/**
 * Flank Speed logo lock-up as on flankspeed.se: symbol + wordmark in Righteous.
 * `product` replaces "CONSULTING" with the product name (e.g. "SETTLED PORTAL").
 * `tone="light"` is for navy/gradient backgrounds.
 */
export default function BrandLogo({
  product = 'Settled Portal',
  tone = 'dark',
  size = 'md',
  className = '',
}: {
  product?: string;
  tone?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const mark = { sm: 'h-7', md: 'h-9', lg: 'h-12' }[size];
  const word = { sm: 'text-[0.95rem]', md: 'text-[1.1rem]', lg: 'text-[1.45rem]' }[size];
  return (
    <span
      className={`inline-flex items-center gap-2.5 whitespace-nowrap ${tone === 'light' ? 'text-white' : 'text-ink'} ${className}`}
      role="img"
      aria-label={`Flank Speed ${product}`}
    >
      <LogoMark className={`w-auto shrink-0 ${mark} ${tone === 'light' ? 'text-white' : 'text-[#3f3f40]'}`} />
      <span aria-hidden className={`font-wordmark leading-none ${word}`}>
        FLANK SPEED <span className="text-[0.64em] uppercase tracking-wide">{product}</span>
      </span>
    </span>
  );
}
